<template>
  <div class="challenges-container scrollable" :class="{'has-parent-page': isSecondTopbarDisplayed}" ref="scrollable">
    <div class="tw-container min-h-screen">
      <SimplifiedHeroNew
        :title="onboardingTextConfig.challengesSimplifiedTitle"
        :subtitle="onboardingTextConfig.challengesSimplifiedSubtitle"
        :action-button="heroActionButton"
        :show-action-button="$store.getters.canCreateChallenge"
      />

      <div
        style="color: var(--primary-community)"
        v-if="isMember || viewableChallengeStatusses.length > 0 || accessibleChallengeStatusses.length > 0"
      >

        <!-- Header -->
        <!--          <div class="bg-white border-b border-gray-200 px-6 py-4 flex-shrink-0">
                    <div class="tw-flex flex-row justify-between">
                      <div class="tw-flex space-x-4 flex-col">
                        <h1 class="text-xl font-semibold text-gray-900">
                          {{ challengesLabel }}<span v-if="totalChallengesCount"> ({{ totalChallengesCount }})</span>
                        </h1>
                        <p class="text-gray-300 !mr-0 !ml-0">{{ onboardingTextConfig.challengesSimplifiedSubtitle }}</p>
                      </div>

                      &lt;!&ndash; New Challenge Button &ndash;&gt;
                      <div v-if="isLoggedIn" class="tw-flex items-center">
                        <button
                          @click="createChallenge"
                          class="inline-flex items-center px-4 py-2 bg-primary text-white text-sm font-medium rounded-md hover:bg-primary-dark transition-colors duration-200"
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="mr-2">
                            <path d="M12 5v14m-7-7h14"/>
                          </svg>
                          {{ $t('create_resource_add') }} {{ challengeLabel }}
                        </button>
                      </div>
                    </div>
                  </div>-->
        <div>

          <div class="modern-filters-container">
            <!-- Compact Single Row Layout -->
            <div class="filters-compact-row">

              <!-- Status & Visibility Filter Group -->
              <div class="filter-group">
                <label class="filter-label">{{ $t('challenges_show_me') }}</label>
                <div class="relative">
                  <button
                    @click="showStatusDropdown = !showStatusDropdown"
                    class="compact-dropdown"
                  >
                    {{ getStatusVisibilityText() }}
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ml-2">
                      <path d="M6 9l6 6 6-6"/>
                    </svg>
                  </button>

                  <!-- Status & Visibility Dropdown -->
                  <div
                    v-if="showStatusDropdown"
                    class="filter-dropdown"
                  >
                    <div class="dropdown-section">
                      <div class="dropdown-section-title">Status</div>
                      <label v-for="status in filters.status" :key="status.value" class="dropdown-option">
                        <input
                          type="checkbox"
                          :checked="activeFilters.status.includes(status.value)"
                          @change="toggleStatusFilter(status.value)"
                        />
                        {{ status.label }}
                      </label>
                    </div>
                    <div class="dropdown-section" v-if="allowVisibilityFilter">
                      <div class="dropdown-section-title">{{ $t('add_challenge_invite_only') }}</div>
                      <label v-for="visibility in filters.visibility" :key="visibility.value" class="dropdown-option">
                        <input
                          type="checkbox"
                          :checked="activeFilters.visibility.includes(visibility.value)"
                          @change="toggleVisibilityFilter(visibility.value)"
                        />
                        {{ visibility.label }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Geography Filter Group -->
              <div class="filter-group" v-if="allowVisibilityFilter && geographyOptions.length > 0">
                <label class="filter-label">{{ $t('add_challenge_geography_scope') }}</label>
                <div class="relative">
                  <button
                    @click="showGeographyDropdown = !showGeographyDropdown"
                    class="compact-dropdown"
                  >
                    {{ getGeographyText() }}
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ml-2">
                      <path d="M6 9l6 6 6-6"/>
                    </svg>
                  </button>

                  <!-- Geography Dropdown -->
                  <div
                    v-if="showGeographyDropdown"
                    class="filter-dropdown"
                  >
                    <label v-for="geo in geographyOptions" :key="geo.value" class="dropdown-option">
                      <input
                        type="checkbox"
                        :checked="activeFilters.geo.includes(geo.value)"
                        @change="toggleGeographyFilter(geo.value)"
                      />
                      {{ geo.label }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- Filter Tags Group -->
              <div class="filter-group" v-if="isLoggedIn">
                <label class="filter-label">{{ $t('challenges_show') }}</label>
                <div class="compact-tags">
                  <button
                    @click="toggleFilter('pinned', true, 'followed')"
                    :class="[
                        'compact-filter-tag',
                        { 'enabled': activeFilters.pinned && activeFilters.pinned.includes(true) }
                      ]"
                  >
                    {{ followedChallengesFilterLabel }}
                  </button>

                  <button
                    @click="setFilter('isCreator', !activeFilters.isCreator, 'created')"
                    :class="[
                        'compact-filter-tag',
                        { 'enabled': activeFilters.isCreator === true }
                      ]"
                  >
                    {{ myChallengesFilterLabel }}
                  </button>
                </div>
              </div>

              <!-- Goals Filter Group -->
              <div class="filter-group" v-if="filterOptions.length > 0">
                <label class="filter-label">{{ $t('challenges_goals') }}</label>
                <div class="relative">
                  <button
                    @click="showGoalsDropdown = !showGoalsDropdown"
                    class="compact-dropdown"
                  >
                    {{ getGoalsText() }}
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="ml-2">
                      <path d="M6 9l6 6 6-6"/>
                    </svg>
                  </button>

                  <!-- Goals Dropdown -->
                  <div
                    v-if="showGoalsDropdown"
                    class="filter-dropdown goals-dropdown"
                  >
                    <label v-for="option in filterOptions" :key="`${option.type}-${option.value}`" class="dropdown-option">
                      <input
                        type="checkbox"
                        :checked="activeFilters[option.type] && activeFilters[option.type].includes(option.value)"
                        @change="toggleTaxonomyFilter(option.type, option.value)"
                      />
                      {{ option.label }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- Actions Group -->
              <div class="filter-actions" v-if="contentIsFiltered">
                <button
                  @click="clearFilters"
                  class="clear-filters-btn"
                  title="Clear all filters"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M3 6h18M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Active Filters Section -->
            <div class="active-filters-section" v-if="hasActiveFilters">
              <div class="active-filters-label">{{ $t('challenges_active_filters') }}:</div>
              <div class="active-filters-tags">
                <!-- Status Filters -->
                <span
                  v-for="status in activeFilters.status"
                  :key="`status-${status}`"
                  class="active-filter-tag"
                  @click="removeFilter('status', status)"
                >
                    {{ getStatusLabel(status) }}
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                  </span>

                <!-- Visibility Filters -->
                <span
                  v-for="visibility in activeFilters.visibility"
                  :key="`visibility-${visibility}`"
                  class="active-filter-tag"
                  @click="removeFilter('visibility', visibility)"
                >
                    {{ getVisibilityLabel(visibility) }}
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                  </span>

                <!-- Geography Filters -->
                <span
                  v-for="geo in activeFilters.geo"
                  :key="`geo-${geo}`"
                  class="active-filter-tag"
                  @click="removeFilter('geo', geo)"
                >
                    {{ getGeographyLabel(geo) }}
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                  </span>

                <!-- Pinned Filter -->
                <span
                  v-if="activeFilters.pinned && activeFilters.pinned.includes(true)"
                  class="active-filter-tag"
                  @click="removeFilter('pinned', true)"
                >
                    {{ followedChallengesFilterLabel }}
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                  </span>

                <!-- My Challenges Filter -->
                <span
                  v-if="activeFilters.isCreator === true"
                  class="active-filter-tag"
                  @click="removeFilter('isCreator', true)"
                >
                    {{ myChallengesFilterLabel }}
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                  </span>

                <!-- Taxonomy Filters -->
                <span
                  v-for="option in getActiveTaxonomyFilters()"
                  :key="`taxonomy-${option.type}-${option.value}`"
                  class="active-filter-tag"
                  @click="removeTaxonomyFilter(option.type, option.value)"
                >
                    {{ option.label }}
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                  </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="fetching">
        <LoadingNew/>
      </div>

      <div v-if="!fetching && challenges.length === 0" class="container">
        <div v-if="contentIsFiltered">
          {{ $t('challenge_none_for_current_filters_1', { challenges: challengesLabel }) }}
          <label-filter
            @updateFilter="clearFilters"
            :model-value="!contentIsFiltered"
            :text="$t('challenges_filters_here')" :is-enabled="!contentIsFiltered"
          />
          {{ $t('challenge_none_for_current_filters_2') }}
        </div>
        <div v-else>
          {{ $t('challenge_none_available', { challenges: challengesLabel }) }}
        </div>
      </div>

      <div class="challenges-grid">
        <ChallengeCardNew
          v-for="challenge in sortedChallenges"
          class="w-full"
          :key="challenge.id"
          :challenge="challenge"
          :is-new="isNewChallenge(challenge)"
          :can-toggle-status-filter="allowStatusFilter"
          :can-toggle-visibility-filter="allowVisibilityFilter"
          @set-filter="toggleFilter($event.target, $event.value)"
        />
      </div>

    </div>
  </div>
</template>

<script>
  import { MUTATION_TYPES as UI_MUTATION_TYPES } from '../store/modules/ui'
  import { getFilterableTags } from '../Domain/Challenge/Api/challenges.ts'
  import { fetchLastVisited } from '../api/user.js'
  import Tag from '../components/Tag/Tag.vue'
  import RichBodyContent from '../components/RichBodyContent/RichBodyContent.vue'
  import _throttle from 'lodash/throttle.js'
  import LabelFilter from '../components/Filters/LabelFilter.vue'
  import ChallengeCard from '../components/Simplified/ChallengeCard.vue'
  import TagsMixin from '../util/TagsMixin.js'
  import { ACTION_TYPES as CHALLENGES_ACTION_TYPES, MUTATION_TYPES as CHALLENGE_MUTATION_TYPES, } from '../store/modules/challenges.js'
  import BasicSimplifiedHero from '../components/Simplified/BasicSimplifiedHero.vue'
  import Container from '../components/Container/Container.vue'
  import SimplifiedFooter from '../components/SimplifiedFooter/SimplifiedFooter.vue'
  import { trackHeapEvent } from '../util/analytics.js'
  import { ecosystemMemberHasAccessToChallenge } from '../util/helpers.js'
  import HoverOverlayButton from '../components/Overlay/HoverOverlayButton.vue'
  import Dropdown from '../components/Dropdown/Dropdown.vue'
  import TranslationsMixin from '../util/TranslationsMixin.js'
  import OnboardingMixin from '../util/OnboardingMixin.js'
  import { defineComponent } from 'vue'
  import SimpleHeading from '@/components/Simplified/SimpleHeading.vue'
  import Calendar from '@/components/Calendar.vue'
  import Loading from '@/components/Dashboard/ConceptMap/Loading.vue'
  import ChallengeCardNew from '@/components/Challenges/ChallengeCardNew.vue'
  import LoadingNew from '@/components/Loaders/LoadingNew.vue'
  import { capitalize } from '@/util/string'
  import SimplifiedHeroNew from '@/components/SimplifiedHero/SimplifiedHeroNew.vue'

  export default defineComponent({
    name: 'Challenges.vue',
    data () {
      return {
        showMoreTags: false,
        showMoreSDGs: false,
        forcedRenders: 0,
        dynamicFilters: {
          tags: [],
          sustainability_goals: [],
          status: [],
          geographies: [],
        },
        selectedCommunity: null,
        isSimplifiedTemplateUsed: true,
        // New filter dropdown states
        searchQuery: '',
        showStatusDropdown: false,
        showGeographyDropdown: false,
        showGoalsDropdown: false,
        searchDebounceTimer: null,
        newSince: null,
      }
    },
    methods: {
      createChallenge () {
        this.$store.commit(UI_MUTATION_TYPES.SHOW_SIDE_PANEL, { component: 'manage-challenge-panel' })
      },
      isAccessibleForUser (challenge) {
        if (this.isMember) {
          return true
        }
        return ecosystemMemberHasAccessToChallenge(challenge, this.userId, this.accessibleChallengeStatusses)
      },
      isNewChallenge (challenge) {
        return !!this.newSince && !!challenge.created_at && new Date(challenge.created_at) > new Date(this.newSince)
      },
      fetchNewSince () {
        fetchLastVisited(['challenges_overview']).then((response) => {
          this.newSince = response.since

          // We've now seen the new items, so the top bar badge count can clear immediately
          // rather than waiting for a full page reload to refetch it.
          this.$store.commit(CHALLENGE_MUTATION_TYPES.FETCH_NEW_CHALLENGES_COUNT_RESULT, { count: 0 })
        }).catch(() => {
          // Ignore errors, "New" tags/sorting simply won't be shown
        })
      },
      loadFilters () {
        getFilterableTags().then((filters) => {
          this.dynamicFilters.sustainability_goals = filters.sdgs || []
          this.dynamicFilters.tags = filters.tags || []
        })
      },
      removeEventListeners () {
        this.$bus.off('challengeUpdated')
        this.$bus.off('challengeDeleted')
        this.$bus.off('challengeCreated')
        this.$refs.scrollable.removeEventListener('scroll', this.onScrollChallenges, { passive: true })
      },
      setupEventListeners () {
        this.$bus.on('challengeUpdated', () => {
          this.resetChallenges()
          this.loadFilters()
          this.fetchChallenges()
        })

        this.$bus.on('challengeDeleted', () => {
          this.resetChallenges()
          this.loadFilters()
          this.fetchChallenges()
        })

        this.$bus.on('challengeCreated', () => {
          this.resetChallenges()
          this.loadFilters()
          this.fetchChallenges()
        })
      },
      clearFilters () {
        trackHeapEvent('challengesSimplified.resetFilters')
        this.$store.commit(CHALLENGE_MUTATION_TYPES.CLEAR_CHALLENGES_FILTER)
        this.resetChallenges()
        this.fetchChallenges()
      },
      setStatusOrVisibilityFilter (value) {
        const statusFilters = value.filter(value => ['new', 'open', 'solved'].includes(value))
        const visibilityFilters = value.filter(value => ['public', 'private'].includes(value))
        this.setFilter('status', statusFilters)
        this.setFilter('visibility', visibilityFilters)
      },
      setFilter (target, value, label) {
        this.$store.commit(CHALLENGE_MUTATION_TYPES.SET_CHALLENGES_FILTER, {
          target,
          value,
        })

        this.resetChallenges()
        this.fetchChallenges()
      },
      toggleFilter (target, value, label, isTaxonomy = false) {
        if (isTaxonomy) {
          this.$store.commit(CHALLENGE_MUTATION_TYPES.TOGGLE_CHALLENGES_FILTER, {
            target: label,
            value: value,
          })

          this.resetChallenges()
          this.fetchChallenges()

          return
        }

        this.$store.commit(CHALLENGE_MUTATION_TYPES.TOGGLE_CHALLENGES_FILTER, {
          target,
          value,
        })

        this.resetChallenges()
        this.fetchChallenges()
      },
      getSelectedTaxonomyValues () {
        const selectedValues = [];
        this.filterOptions.forEach(option => {
          if (this.activeFilters[option.type] && this.activeFilters[option.type].indexOf(option.value) >= 0) {
            selectedValues.push(option.value);
          }
        });
        return selectedValues;
      },
      setTaxonomyFilter (selectedValues) {
        // Clear all existing taxonomy filters first
        this.filterOptions.forEach(option => {
          if (this.activeFilters[option.type]) {
            this.$store.commit(CHALLENGE_MUTATION_TYPES.SET_CHALLENGES_FILTER, {
              target: option.type,
              value: [],
            });
          }
        });

        // Set new values
        selectedValues.forEach(value => {
          const option = this.filterOptions.find(opt => opt.value === value);
          if (option) {
            this.$store.commit(CHALLENGE_MUTATION_TYPES.TOGGLE_CHALLENGES_FILTER, {
              target: option.type,
              value: value,
            });
          }
        });

        this.resetChallenges()
        this.fetchChallenges()
      },
      removeFilter (target, value) {
        if (target === 'status' || target === 'visibility') {
          const currentValues = this.activeFilters[target] || [];
          const newValues = currentValues.filter(v => v !== value);
          this.setFilter(target, newValues);
        } else if (target === 'pinned') {
          this.setFilter('pinned', []);
        } else if (target === 'isCreator') {
          this.setFilter('isCreator', false);
        } else {
          const currentValues = this.activeFilters[target] || [];
          const newValues = currentValues.filter(v => v !== value);
          this.setFilter(target, newValues);
        }
      },
      removeTaxonomyFilter (type, value) {
        this.$store.commit(CHALLENGE_MUTATION_TYPES.TOGGLE_CHALLENGES_FILTER, {
          target: type,
          value: value,
        });
        this.resetChallenges()
        this.fetchChallenges()
      },
      getStatusLabel (status) {
        const statusMap = {
          'new': this.$t('challenges_new'),
          'open': this.$t('challenges_open'),
          'solved': this.$t('challenges_solved')
        };
        return statusMap[status] || status;
      },
      getVisibilityLabel (visibility) {
        const visibilityMap = {
          'public': this.$t('challenges_public'),
          'private': this.$t('challenges_private')
        };
        return visibilityMap[visibility] || visibility;
      },
      getGeographyLabel (geoValue) {
        const geo = this.geographyOptions.find(g => g.value === geoValue);
        return geo ? geo.label : geoValue;
      },
      getActiveTaxonomyFilters () {
        const activeFilters = [];
        this.filterOptions.forEach(option => {
          if (this.activeFilters[option.type] && this.activeFilters[option.type].indexOf(option.value) >= 0) {
            activeFilters.push(option);
          }
        });
        return activeFilters;
      },
      fetchChallenges () {
        if (this.fetching) {
          return
        }

        this.$store.dispatch(CHALLENGES_ACTION_TYPES.FETCH_CHALLENGES_LIST, {
          limit: this.fetchLimit,
          offset: this.flushCache ? 0 : (this.searchQuery ? 0 : this.challenges.length),
          filters: { ...this.activeFilters, communityId: this.communityId, query: this.searchQuery },
        })
      },
      onScrollChallenges: _throttle(function () {
        const elem = this.$refs.scrollable
        if (elem && elem.offsetHeight + elem.scrollTop > 0.95 * elem.scrollHeight - 1500 && !this.endOfFeed) {
          this.fetchChallenges()
        }
      }, 1000),
      resetChallenges () {
        this.$store.commit(CHALLENGE_MUTATION_TYPES.FLUSH_CACHE)
      },

      // New methods for modern input fields
      onSearchChange () {
        // Debounce search to avoid too many API calls
        clearTimeout(this.searchDebounceTimer)
        this.searchDebounceTimer = setTimeout(() => {
          this.fetchChallenges()
          console.log('Search query:', this.searchQuery)
        }, 300)
      },

      getStatusVisibilityText () {
        const statusCount = this.activeFilters.status.length
        const visibilityCount = this.activeFilters.visibility.length
        const total = statusCount + visibilityCount

        if (total === 0) {
          return this.$t('challenges_filter_all')
        }

        /*if (total === 1) {
          if (statusCount === 1) {
            return this.getStatusLabel(this.activeFilters.status[0])
          }
          return this.getVisibilityLabel(this.activeFilters.visibility[0])
        }*/

        return this.$t('challenges_filters_selected', { count: total }) /*`${total} selected`*/
      },

      getGeographyText () {
        const count = this.activeFilters.geo?.length || 0
        if (count === 0) {
          return this.$t('challenges_filter_any')
        }

        /*if (count === 1) {
          return this.getGeographyLabel(this.activeFilters.geo[0])
        }*/

        return this.$t('challenges_filters_selected', { count: count })
      },

      getGoalsText () {
        const count = this.getActiveTaxonomyFilters().length
        if (count === 0) {
          return this.$t('challenges_filter_any')
        }

        /*if (count === 1) {
          return this.getActiveTaxonomyFilters()[0].label
        }*/

        return this.$t('challenges_filters_selected', { count: count })
      },

      toggleStatusFilter (statusValue) {
        const currentStatus = this.activeFilters.status || []
        const newStatus = currentStatus.includes(statusValue)
          ? currentStatus.filter(s => s !== statusValue)
          : [...currentStatus, statusValue]

        this.setFilter('status', newStatus)
      },

      toggleVisibilityFilter (visibilityValue) {
        const currentVisibility = this.activeFilters.visibility || []
        const newVisibility = currentVisibility.includes(visibilityValue)
          ? currentVisibility.filter(v => v !== visibilityValue)
          : [...currentVisibility, visibilityValue]

        this.setFilter('visibility', newVisibility)
      },

      toggleGeographyFilter (geoValue) {
        const currentGeo = this.activeFilters.geo || []
        const newGeo = currentGeo.includes(geoValue)
          ? currentGeo.filter(g => g !== geoValue)
          : [...currentGeo, geoValue]

        this.setFilter('geo', newGeo)
      },

      toggleTaxonomyFilter (type, value) {
        this.$store.commit(CHALLENGE_MUTATION_TYPES.TOGGLE_CHALLENGES_FILTER, {
          target: type,
          value: value,
        })

        this.resetChallenges()
        this.fetchChallenges()
      },

      handleClickOutside (event) {
        // Close all dropdowns when clicking outside
        if (!event.target.closest('.filter-dropdown') && !event.target.closest('.compact-dropdown')) {
          this.showStatusDropwdown = false
          this.showGeographyDropdown = false
          this.showGoalsDropdown = false
        }
      },
    },
    computed: {
      heroActionButton () {
        return {
          label: this.$t('add_challenge_panel_title', { challenge: this.challengeLabel }),
          icon: 'plus',
          variant: 'rounded',
          onClick: () => this.createChallenge()
        }
      },
      myChallengesLabel () {
        return capitalize(this.$t('challenges_my'))
      },
      myFollowedLabel () {
        return capitalize(this.$t('challenges_followed'))
      },
      myChallengesFilterLabel () {
        return this.myChallengesLabel + ' ' + this.challengesLabel
      },
      followedChallengesFilterLabel () {
        return this.myFollowedLabel + ' ' + this.challengesLabel
      },
      filterOptions () {
        const facetCounts = this.$store.state.challenges.listData.facetCounts;

        const allItems = [
          ...(facetCounts.activities || []).map(item => ({
            value: item.value,
            label: this.getLabelForTaxonomyValue('activities', item.value) || item.label,
            type: 'activity',
            count: item.count
          })),
          ...(facetCounts.industries || []).map(item => ({
            value: item.value,
            label: this.getLabelForTaxonomyValue('industries', item.value) || item.label,
            type: 'industry',
            count: item.count
          })),
          ...(facetCounts.technologies || []).map(item => ({
            value: item.value,
            label: this.getLabelForTaxonomyValue('technologies', item.value) || item.label,
            type: 'technology',
            count: item.count
          })),
          ...(facetCounts.domains || []).map(item => ({
            value: item.value,
            label: this.getLabelForTaxonomyValue('domains', item.value) || item.label,
            type: 'domain',
            count: item.count
          })),
          ...(facetCounts.stages || []).map(item => ({
            value: item.value,
            label: this.getLabelForTaxonomyValue('stages', item.value) || item.label,
            type: 'stage',
            count: item.count
          })),
        ];

        // Sort by count descending to show most popular options first
        return allItems.sort((a, b) => b.count - a.count);
      },
      communityId () {
        return this.$route.params.communityId
      },
      isSecondTopbarDisplayed () {
        return this.$route.name === 'community-detail'
      },
      ecosystemColor () {
        return this.$store.state.config.primaryColor
      },
      communities () {
        return this.$store.state.communities.listData.data.map((community) => {
          return {
            label: community.name,
            value: community.id
          }
        })
      },
      filters () {
        return {
          isCreator: false,
          sustainability_goals: [],
          tags: [],
          visibility: [
            { label: this.$t('challenges_public'), value: 'public' },
            { label: this.$t('challenges_private'), value: 'private' },
          ],
          a: 1,
          status: [
            { label: this.$t('challenges_new'), value: 'new' },
            { label: this.$t('challenges_open'), value: 'open' },
            { label: this.$t('challenges_solved'), value: 'solved' },
          ],
          pinned: [
            { label: this.$t('challenges_followed'), value: true },
          ],
        }
      },
      sidePanelIsVisible () {
        return this.$store.state.ui.sidePanel.isVisible
      },
      canCreateChallenge () {
        return this.$store.getters.canCreateChallenge
      },
      challengeList () {
        return this.$store.state.challenges.listData
      },
      challenges () {
        return this.challengeList.data
      },
      sortedChallenges () {
        if (!this.newSince) {
          return this.challenges
        }

        const newChallenges = []
        const restChallenges = []
        this.challenges.forEach(challenge => {
          (this.isNewChallenge(challenge) ? newChallenges : restChallenges).push(challenge)
        })

        return [...newChallenges, ...restChallenges]
      },
      flushCache () {
        return this.challengeList.flushCache
      },
      fetchLimit () {
        return this.challengeList.fetchLimit
      },
      endOfFeed () {
        return this.challengeList.endOfFeed
      },
      fetching () {
        return this.challengeList.loading
      },
      totalChallengesCount () {
        return this.$store.state.challenges.challengesCount
      },
      allowStatusFilter () {
        return this.isMember || this.viewableChallengeStatusses.length > 1
      },
      allowVisibilityFilter () {
        return !!this.isLoggedIn
      },
      isLoggedIn () {
        return this.$store.getters.isLoggedIn
      },
      userId () {
        return this.$store.state.user.profile.id
      },
      accessibleChallengeStatusses () {
        return this.$store.getters.accessibleChallengeStatusses
      },
      viewableChallengeStatusses () {
        return this.$store.getters.viewableChallengeStatusses
      },
      displayedTags () {
        const displayedTags = this.dynamicFilters.tags.sort((tag1, tag2) => {
          return this.activeFilters.tags.indexOf(tag2.value) - this.activeFilters.tags.indexOf(tag1.value)
        })
        return this.showMoreTags ? displayedTags : displayedTags.slice(0, 12)
      },
      geographyOptions () {
        const allGeographies = this.challenges.flatMap(
          challenge => challenge.geographicalLabels || []
        ).filter(Boolean);

        const seen = new Set();
        return allGeographies
          .filter(geo => {
            if (seen.has(geo.value)) return false;
            seen.add(geo.value);
            return true;
          })
          .map(geo => ({ label: geo.label, value: geo.value }));
      },
      displayedSDGs () {
        return this.showMoreSDGs ? this.dynamicFilters.sustainability_goals : this.dynamicFilters.sustainability_goals.slice(0, 4)
      },
      contentIsFiltered () {
        return this.activeFilters.sustainability_goals.length > 0 ||
          this.activeFilters.tags.length > 0 ||
          this.activeFilters.visibility.length > 0 ||
          this.activeFilters.status.length > 0 ||
          this.activeFilters.pinned.length > 0 ||
          this.activeFilters.activity.length > 0 ||
          this.activeFilters.industry.length > 0 ||
          this.activeFilters.technology.length > 0 ||
          this.activeFilters.domain.length > 0 ||
          this.activeFilters.stage.length > 0 ||
          this.activeFilters.geo.length > 0 ||
          this.activeFilters.isCreator
      },
      activeFilters () {
        return this.$store.state.challenges.challengesFilters
      },
      isOwner () {
        return this.$store.getters.isOwner
      },
      isMember () {
        // Is team member or ecosystem owner
        return this.$store.getters.isMember
      },
      localizedTitle () {
        return this.challengesLabel
      },
      hasActiveFilters () {
        return (
          (this.activeFilters.status && this.activeFilters.status.length > 0) ||
          (this.activeFilters.visibility && this.activeFilters.visibility.length > 0) ||
          (this.activeFilters.geo && this.activeFilters.geo.length > 0) ||
          (this.activeFilters.pinned && this.activeFilters.pinned.includes(true)) ||
          this.activeFilters.isCreator === true ||
          this.getActiveTaxonomyFilters().length > 0
        );
      },
    },
    created () {
      this.fetchChallenges()
      this.loadFilters()

      this.setupEventListeners()
    },
    mounted () {
      this.$store.dispatch(CHALLENGES_ACTION_TYPES.FETCH_CHALLENGES_COUNT, {
        communityId: this.communityId
      })

      this.$store.commit(CHALLENGE_MUTATION_TYPES.CLEAR_CHALLENGES_FILTER)
      this.fetchNewSince()

      if (!this.challenges.length) {
        this.fetchChallenges()
      }

      this.$refs.scrollable.addEventListener('scroll', this.onScrollChallenges, { passive: true })

      // Add click outside listener for dropdowns
      document.addEventListener('click', this.handleClickOutside)

      if (this.$route.query.openModal) {
        this.createChallenge()
        this.$router.replace({ 'query': null })
      }
    },
    beforeUnmount () {
      this.removeEventListeners()

      // Remove click outside listener
      document.removeEventListener('click', this.handleClickOutside)

      // Clear search debounce timer
      clearTimeout(this.searchDebounceTimer)

      // Remove click outside listener
      document.removeEventListener('click', this.handleClickOutside)

      // Clear search debounce timer
      clearTimeout(this.searchDebounceTimer)

      this.$store.commit(UI_MUTATION_TYPES.HIDE_SIDE_PANEL)
    },
    watch: {
      '$route.params.communityId': {
        async handler () {
          if (!this.$route.params.communityId) {
            this.setFilter('communityIds', [])
          }

          await this.$store.dispatch(CHALLENGES_ACTION_TYPES.FETCH_CHALLENGES_COUNT, {
            communityIds: [this.communityId]
          })

          await this.$store.commit(CHALLENGE_MUTATION_TYPES.FLUSH_CACHE)

          this.$store.dispatch(CHALLENGES_ACTION_TYPES.FETCH_CHALLENGES_LIST, {
            limit: this.fetchLimit,
            offset: 0,
            filters: { ...this.activeFilters, communityId: this.communityId },
          })
        },
        immediate: true,
      }
    },
    components: {
      SimplifiedHeroNew,
      LoadingNew,
      ChallengeCardNew,
      Loading, Calendar, SimpleHeading,
      Dropdown,
      HoverOverlayButton,
      SimplifiedFooter,
      Container,
      BasicSimplifiedHero,
      Tag,
      ChallengeCard,
      RichBodyContent,
      LabelFilter,
    },
    mixins: [TagsMixin, TranslationsMixin, OnboardingMixin],
  })
</script>

<style lang="scss" scoped>
  @import "../../scss/variables.scss";

  .challenges-box {
    display: flex;
    margin-top: 2rem;
    justify-content: space-between;
  }

  .challenges-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 2rem;
    margin-top: 2rem;
    justify-items: center;
    align-items: start;
    width: 100%;

    // Ensure we have max 3 columns on larger screens
    @media (min-width: 1200px) {
      grid-template-columns: repeat(3, 1fr);
    }

    // 2 columns on medium screens
    @media (min-width: 768px) and (max-width: 1199px) {
      grid-template-columns: repeat(2, 1fr);
    }

    // Single column on mobile
    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      gap: 1.5rem;
    }
  }

  .modern-filters-container {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    padding: 0.75rem;
    margin: 1rem 0;
    border: 1px solid #e5e7eb;

    .filters-compact-row {
      display: flex;
      align-items: center;
      gap: 1rem;
      flex-wrap: wrap;

      .filter-group {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        min-width: 120px;

        &.search-group {
          flex: 1;
          min-width: 200px;

          .search-input-wrapper {
            position: relative;
            flex: 1;

            .compact-search-input {
              width: 100%;
              padding: 0.375rem 0.75rem 0.375rem 2.25rem;
              border: 1px solid #d1d5db;
              border-radius: 6px;
              font-size: 0.875rem;
              color: #374151;
              background: #ffffff;
              transition: all 0.2s ease;

              &:focus {
                outline: none;
                border-color: var(--primary-community, #3b82f6);
                box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
              }

              &::placeholder {
                color: #9ca3af;
              }
            }

            .search-icon {
              position: absolute;
              left: 0.75rem;
              top: 50%;
              transform: translateY(-50%);
              color: #9ca3af;
              pointer-events: none;
            }
          }
        }

        .filter-label {
          font-weight: 500;
          font-size: 0.75rem;
          color: #6b7280;
          white-space: nowrap;
          text-transform: uppercase;
          letter-spacing: 0.025em;
        }

        .compact-dropdown {
          display: inline-flex;
          align-items: center;
          min-width: 120px;
          max-width: 200px;
          padding: 0.375rem 0.75rem;
          background: #ffffff;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          font-size: 0.875rem;
          color: #374151;
          cursor: pointer;
          transition: all 0.2s ease;

          &:hover {
            background: #f9fafb;
            border-color: #9ca3af;
          }

          &:focus {
            outline: none;
            border-color: var(--primary-community, #3b82f6);
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }
        }

        .compact-tags {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          flex-wrap: wrap;

          .compact-filter-tag {
            background: #f9fafb;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            padding: 0.25rem 0.5rem;
            font-size: 0.75rem;
            color: #6b7280;
            cursor: pointer;
            transition: all 0.2s ease;
            display: inline-flex;
            align-items: center;
            white-space: nowrap;

            &:hover {
              background: #f3f4f6;
              border-color: #d1d5db;
            }

            &.enabled {
              background: var(--primary-community, #3b82f6);
              color: white;
              border-color: var(--primary-community, #3b82f6);

              &:hover {
                background: var(--primary-community-hover, #2563eb);
              }
            }
          }

          .more-indicator {
            background: #f3f4f6;
            border: 1px solid #e5e7eb;
            border-radius: 12px;
            padding: 0.25rem 0.5rem;
            font-size: 0.75rem;
            color: #6b7280;
            font-weight: 500;
          }
        }
      }

      .filter-actions {
        margin-left: auto;

        .clear-filters-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 28px;
          height: 28px;
          background: #f3f4f6;
          color: #6b7280;
          border: 1px solid #e5e7eb;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s ease;

          &:hover {
            background: #e5e7eb;
            color: #374151;
            border-color: #d1d5db;
          }

          svg {
            width: 14px;
            height: 14px;
          }
        }
      }
    }

    // Filter dropdowns
    .filter-dropdown {
      position: absolute;
      top: 100%;
      left: 0;
      margin-top: 0.5rem;
      min-width: 120px;
      background: #ffffff;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
      z-index: 50;
      max-height: 300px;
      overflow-y: auto;

      &.goals-dropdown {
        min-width: max-content;
      }

      .dropdown-section {
        padding: 0.75rem 0;

        &:not(:last-child) {
          border-bottom: 1px solid #f3f4f6;
        }

        .dropdown-section-title {
          font-weight: 600;
          font-size: 0.75rem;
          color: #374151;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          padding: 0 1rem 0.5rem 1rem;
        }
      }

      .dropdown-option {
        display: flex;
        gap: 0.5rem;
        padding-left: 0.5rem;
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        margin-right: 0.5rem;
        cursor: pointer;
        transition: all 0.2s ease;
        font-size: 0.875rem;
        color: #374151;

        &:hover {
          background: #f9fafb;
        }

        input[type="checkbox"] {
          width: 16px;
          height: 16px;
          accent-color: var(--primary-community, #3b82f6);
          cursor: pointer;
        }
      }
    }

    .active-filters-section {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      padding-top: 0.75rem;
      margin-top: 0.75rem;
      border-top: 1px solid #f3f4f6;

      .active-filters-label {
        font-weight: 500;
        font-size: 0.75rem;
        color: #6b7280;
        white-space: nowrap;
        text-transform: uppercase;
        letter-spacing: 0.025em;
      }

      .active-filters-tags {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
        flex: 1;

        .active-filter-tag {
          display: inline-flex;
          align-items: center;
          gap: 0.375rem;
          background: var(--primary-community, #3b82f6);
          color: white;
          border: 1px solid var(--primary-community, #3b82f6);
          border-radius: 16px;
          padding: 0.25rem 0.625rem;
          font-size: 0.75rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
          white-space: nowrap;

          &:hover {
            background: var(--primary-community-lighter, #dbeafe);
            border-color: var(--primary-community-lighter, #dbeafe);
            transform: translateY(-1px);
          }

          svg {
            width: 12px;
            height: 12px;
            opacity: 0.8;
          }

          &:hover svg {
            opacity: 1;
          }
        }
      }
    }
  }

  // Responsive design
  @media (max-width: 768px) {
    .modern-filters-container {
      padding: 0.5rem;

      .filters-compact-row {
        flex-direction: column;
        align-items: stretch;
        gap: 0.75rem;

        .filter-group {
          flex-direction: column;
          align-items: stretch;
          gap: 0.25rem;

          .filter-label {
            font-size: 0.7rem;
          }

          .compact-dropdown {
            min-width: auto;
            max-width: none;
          }

          .compact-tags {
            justify-content: flex-start;
          }
        }

        .filter-actions {
          margin-left: 0;
          align-self: flex-end;
        }
      }
    }
  }
</style>
